/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiKeyResponse } from '../../models/api-key-response';
import { UpdateApiKeyRequest } from '../../models/update-api-key-request';

export interface PutApiKey$Params {
  'Active-Tenant-Identifier': string;
  apiKeyId: string;
      body: UpdateApiKeyRequest
}

export function putApiKey(http: HttpClient, rootUrl: string, params: PutApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeyResponse>> {
  const rb = new RequestBuilder(rootUrl, putApiKey.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('apiKeyId', params.apiKeyId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiKeyResponse>;
    })
  );
}

putApiKey.PATH = '/api-keys/{apiKeyId}';
